import { render } from "./admin-department.vue?vue&type=template&id=96995c48"
import script from "./admin-department.vue?vue&type=script&lang=js"
export * from "./admin-department.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/admin/admin-department.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "96995c48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('96995c48', __exports__)) {
    api.reload('96995c48', __exports__)
  }
  
  module.hot.accept("./admin-department.vue?vue&type=template&id=96995c48", () => {
    api.rerender('96995c48', render)
  })

}


export default __exports__